module.exports = __webpack_public_path__ + "assets/img/img176.d3c69ddc.png";